<template>
  <no-ssr-loader>
    <b-container class="py-5">
      <b-row align-v="center">
        <b-col cols="8">
          <h1 class="mb-3">
            {{ isEdit ? 'Edit Catalogue' : 'Create New Catalogue' }}
          </h1>
        </b-col>
        <b-col
          cols="4"
          class="text-right"
        >
          <b-button
            to="/catalogues/view"
            variant="primary"
            class="ml-auto"
          >
            View Catalogues
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12">
          <catalogue-form :catalogueid="catalogueid" />
        </b-col>
      </b-row>
    </b-container>
  </no-ssr-loader>
</template>

<script>
import CatalogueForm from '../components/CatalogueForm'

export default {
  name: 'catalogue-editor',
  components: {
    CatalogueForm
  },
  props: {
    catalogueid: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    isEdit() {
      return this.catalogueid !== ''
    }
  }
}
</script>
